const mixins = {
    visibleScrollbar: {
        '&::-webkit-scrollbar-thumb': {
            borderRadius: '8px',
            border: '2px solid #ffffff00',
            backgroundColor: 'rgba(0, 0, 0, 0.5)'
        },
        '&::-webkit-scrollbar:horizontal': {
            height: '11px'
        },
        '&::-webkit-scrollbar:vertical': {
            width: '8px'
        }
    },
    toolbar: {
        minHeight: 60
    }
};
export { mixins };

//# sourceMappingURL=mixins.js.map